import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KnBrRecentCustomerResultComponent } from './kn-br-recent-customer-result.component';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { SpinnerModule } from '@spartacus/storefront';
import { KnBrCustomPipesModule } from 'src/app/shared/pipe/kn-br-custom-pipes/kn-br-custom-pipes.module';

@NgModule({
    imports: [
        CommonModule,
        I18nModule,
        SpinnerModule,
        KnBrCustomPipesModule,
        ConfigModule.withConfig({
            cmsComponents: {
                KnBrRecentCustomersComponent: {
                    component: KnBrRecentCustomerResultComponent,
                },
            },
        } as CmsConfig),
        KnBrRecentCustomerResultComponent,
    ],
})
export class KnBrRecentCustomerResultModule {}
